import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { KeycloakService } from '../services/keycloak.service';
import { SentryUserService } from '../services/sentry-user.service';

/**
 * Auth guard for route protection with Keycloak
 *
 * Usage in routes:
 * { path: 'dashboard', component: Dashboard, canActivate: [authGuard] }
 */
export const authGuard: CanActivateFn = (route, state) => {
  const keycloakService = inject(KeycloakService);
  const sentryUserService = inject(SentryUserService);

  if (keycloakService.isLoggedIn()) {
    // Fire and forget: attach the user id to Sentry events without delaying navigation.
    void sentryUserService.identifyAuthenticatedUser();
    return true;
  }

  // User is not logged in - initiate login and return to the requested route afterwards.
  // state.url is the target URL (guards run before the URL commits, so window.location is not yet updated).
  keycloakService.login(state.url);
  return false;
};
